import { render, staticRenderFns } from "./PageStatus.vue?vue&type=template&id=e4522ba4&scoped=true&"
import script from "./PageStatus.vue?vue&type=script&lang=js&"
export * from "./PageStatus.vue?vue&type=script&lang=js&"
import style0 from "./PageStatus.vue?vue&type=style&index=0&id=e4522ba4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4522ba4",
  null
  
)

export default component.exports